// extracted by mini-css-extract-plugin
export var boxItems = "_88-1";
export var boxItemsLg = "_88-2";
export var button = "_88-7";
export var buttonHoverless = "_88-9";
export var buttonLg = "_88-8";
export var filterGroupBox = "_88-0";
export var icon = "_88-3";
export var iconSecondary = "_88-6";
export var iconWrapper = "_88-4";
export var iconWrapperLg = "_88-5";
export var truncatedLabel = "_88-a";